/**=========================================================
 * Module: invoices.js
 * Invoices Controller
 =========================================================*/

App.controller('InvoicesController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService','ngDialog',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, ngDialog) {
    "use strict";

    $scope.type = 'offer';
    let client = $state.params.filter
    $scope.filter = '_' + (client ? client : 'leo') + 'Invoices=true&_mode=list';

    $scope.data = [];

    $scope.openOfferDetails = function(offer){
    	if(offer.total){
	    	offer.loadingDetails = true;
	    	var scope = $scope.$new();
	    	D.load('offer', offer.id).then(function(response){
                scope.offer = response
                D.query('offer', 'project='+offer.project+'&supplier='+offer.supplier+'&sum=false').then(
	                function(response){
	                	offer.loadingDetails = false;
	                	offer.offers = response;
                        offer.totalOfferBeforeDiscount = offer.offers.reduce((prev, curr) => prev + curr.total, 0)
	                	ngDialog.open({
	                	      template: '/app/views/entities/offer-details.html',
	                	      className: 'ngdialog-theme-default ngdialog-theme-large',
	                	      scope: scope,
	                	      cache: false
	                	    })
	                }
	            ).catch(console.error);
            })
	    	
    	}
    };

    $scope.toggleInvoiced = function(o){
        o.action = 'SetInvoiced'
        for(var i=0; i<$scope.data.length; i++){
            if($scope.data[i].id==o.id){
                $scope.data[i]._status_invoiced = 'status-pending'
                D.save('offer', o).then(function(r){
                    $scope.data[i]._status_invoiced = ''
                }).catch(function(e){
                    $scope.data[i]._status_invoiced = 'status-error'
                })
                break
            }
        }
    }

    $scope.initialized = false;
    $scope.watchActivated = false;
    $scope.init = function(){

        if($rootScope.user.id){
            $scope.initialized = true;

            var title = 'labels.INVOICES';

            $scope.page = {
                    title: title,
                    subTitle: ''
                };

            $scope.table = {
                type: 'offer',
                title: '',
                filter: true,
                orderBy: '',
                order: '',
                includedFields: ['id','project'],
                fields: [
                    {
                    	available: false,
                    	name: 'createdOn',
                    	type: 'date',
                        filterType: 'date',
                        filterValue: ''
                    },{
                    	available: true,
                    	name: 'projectCode',
                        filterType: 'text',
                        filterValue: '',
                        compareType: 'projectCode',
                        hasLink: $rootScope.user.groupType!='SUPPLIER' ? true : false
                    },{
                    	available: true,
                    	name: 'projectName',
                        filterType: 'text',
                        filterValue: '',
                        hasLink: $rootScope.user.groupType=='SUPPLIER' ? true : false,
						style: {
							width: '400px'
						}
                    },{
                    	available: $rootScope.user.groupType!='CLIENT',
                        name: 'clientName',
                    },{
                        available: true,
                        name: 'notes',
                        type: 'ellipsed'
                    },{
                    	available: true,
                        name: 'total',
                        type: 'currency',
                        filterType: 'number',
                        filterValue: '',
                        decimalSep: $rootScope.user.decimalSep
                    },{
                    	available: true,
                        name: 'invoiced',
                        label: 'invoiced',
                        type: 'checkbox',
                        filterType: 'select',
                        filterOptions: [
                                        {value:' ', label:' '},
                                        {value:"true", label:'enums.confirmedStatus.YES'},
                                        {value:"false", label:'enums.confirmedStatus.NO'}
                                        ],
                        onchange: function(m, i){ $scope.toggleInvoiced(m, i) }
                    },{
                        available: true,
                    	name: 'pdf',
                        hasUrl: 'pdf',
                    	icon: 'aqi-file-pdf'
                    }
                ],
                link: {
                	state: $rootScope.user.groupType=='SUPPLIER' ? 'app.entity' : 'app.do',
                	action: $rootScope.user.groupType=='SUPPLIER' ? 'estimate' : 'open',
                    type: 'project',
                    filter: 'project'
                },
                loading: true
            };

            $scope.table.baseFilter = $scope.filter;
            
            $scope.table.loadCallback = function(scope){
                let newData = []
                for(var i=0; i<scope.data.length; i++){
                    scope.data[i].pdf = $rootScope.app.config.functionsUrl + '/pdf?type=offer&id=' + scope.data[i].id + '&access_token=' + $rootScope.FB.token
                    if($rootScope.user.group.type=='CLIENT'){
                            if($rootScope.user.superUser || scope.data[i].projectOwner==$rootScope.user.id){
                                newData.push(scope.data[i]);
                            }
                    } else {
                        newData.push(scope.data[i]);
                    }
                }
                $scope.page.subTitle = newData[0].clientName;
                scope.data = newData
            }



        } else {
            if(!$scope.watchActivated){
                $scope.watchActivated = true;
                $rootScope.$watch('user.id', function(){
                    if(!$scope.initialized){
                        $scope.init();
                    }
                });
            }
        }
    }

    $scope.init();

    $scope.$on('$destroy', function iVeBeenDismissed() {
      // say goodbye to your controller here
      // release resources, cancel request...
      $scope.load = function() { };
    });

}]);
